/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */

import { Component, input } from '@angular/core';

@Component({
  selector: 'ods-attachment-header',
  host: { class: 'flex h-11 items-center justify-between px-3 text-text text-sm font-medium empty:hidden' },
  template: `@if (title()) {
      @if (isStrong()) {
        <strong>{{ title() }}</strong>
      } @else {
        <span role="heading" [aria-level]="headingLevel()">{{ title() }}</span>
      }
    }
    <ng-content select="[action-buttons]" />`,
})
export class AttachmentHeaderComponent {
  public readonly title = input<string>('');
  public readonly headingLevel = input<2 | 3 | 4 | 5 | 6>(4);
  public readonly isStrong = input<boolean>(false);
}
